/**
 * Règles de disponibilité des rendez-vous — source unique, partagée.
 *
 * Ce fichier ne contient AUCUNE règle nouvelle : il rassemble celles qui vivaient jusqu'ici en
 * double dans devis-rdv-widget.js et dans sync-server/server.js (jours fériés, week-ends,
 * fermetures déclarées, créneaux, délai minimum). Le but est qu'il n'existe qu'un seul endroit
 * où l'on décide si une date est proposable au client :
 *   - le widget de devis/RDV (toutes prestations) l'utilise pour son calendrier ;
 *   - la page panier l'utilise pour le rendez-vous de montage des pneus ;
 *   - sync-server/server.js applique les mêmes règles et fait foi à la soumission.
 *
 * Deux délais minimum coexistent, et c'est voulu :
 *   - prestations classiques : 48 heures (RDV_DELAI_HEURES) ;
 *   - pneus : 5 jours ouvrés (RDV_DELAI_JOURS_OUVRES), le temps que le fournisseur livre.
 *
 * « Jour ouvré » = du lundi au vendredi, hors jours fériés. Les fermetures déclarées par le
 * garage ne RALLONGENT PAS ce décompte : elles rendent seulement la date concernée
 * indisponible. C'est la règle arrêtée avec le garage.
 */
(function () {
  'use strict';

  var CRENEAUX = ['8h-10h', '10h-12h', '14h-16h', '16h-18h'];
  var RDV_DELAI_HEURES = 48;
  var RDV_DELAI_JOURS_OUVRES = 5;

  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var JOURS_COURTS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function versChaine(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }

  // Comput ecclésiastique (algorithme de Meeus/Jones/Butcher) — repris tel quel de
  // devis-rdv-widget.js, il sert à placer lundi de Pâques, Ascension et lundi de Pentecôte.
  function paques(annee) {
    var a = annee % 19;
    var b = Math.floor(annee / 100);
    var c = annee % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mois = Math.floor((h + l - 7 * m + 114) / 31);
    var jour = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(annee, mois - 1, jour);
  }

  var cacheFeries = {};
  function feriesDeLAnnee(annee) {
    if (cacheFeries[annee]) return cacheFeries[annee];
    var set = {};
    function fixe(m, j) { set[annee + '-' + pad2(m) + '-' + pad2(j)] = true; }
    fixe(1, 1); fixe(5, 1); fixe(5, 8); fixe(7, 14);
    fixe(8, 15); fixe(11, 1); fixe(11, 11); fixe(12, 25);
    var p = paques(annee);
    function decale(jours) {
      var d = new Date(p.getTime());
      d.setDate(d.getDate() + jours);
      set[versChaine(d)] = true;
    }
    decale(1); decale(39); decale(50);
    cacheFeries[annee] = set;
    return set;
  }

  function estFerie(d) {
    return !!feriesDeLAnnee(d.getFullYear())[versChaine(d)];
  }

  function estWeekEnd(d) {
    var j = d.getDay(); // 0 = dimanche, 6 = samedi
    return j === 0 || j === 6;
  }

  // Fermetures : tableau de { debut, fin } au format 'YYYY-MM-DD'. Comparaison lexicographique
  // valide puisque le format est complété par des zéros.
  function estFermeture(chaineDate, fermetures) {
    if (!fermetures) return false;
    for (var i = 0; i < fermetures.length; i++) {
      var f = fermetures[i];
      if (f && f.debut && f.fin && chaineDate >= f.debut && chaineDate <= f.fin) return true;
    }
    return false;
  }

  function estSelectionnable(d, dateMin, fermetures) {
    if (d < dateMin) return false;
    if (estWeekEnd(d)) return false;
    if (estFerie(d)) return false;
    if (estFermeture(versChaine(d), fermetures)) return false;
    return true;
  }

  // Délai des prestations classiques : une simple durée.
  function dateMinParHeures(heures) {
    var d = new Date(Date.now() + (heures || RDV_DELAI_HEURES) * 3600 * 1000);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  // Délai des pneus : on avance de N jours ouvrés à partir de demain. Les fermetures ne sont
  // volontairement PAS déduites ici — elles n'allongent pas le délai, elles se contentent de
  // griser la date au moment de l'affichage (cf. estSelectionnable).
  // `depuis` n'est utilisé que par les tests et par le serveur, qui doit pouvoir recalculer le
  // délai à partir de la date de la commande plutôt que du jour courant.
  function dateMinParJoursOuvres(jours, depuis) {
    var restants = typeof jours === 'number' ? jours : RDV_DELAI_JOURS_OUVRES;
    var d = depuis ? new Date(depuis.getTime()) : new Date();
    d.setHours(0, 0, 0, 0);
    while (restants > 0) {
      d.setDate(d.getDate() + 1);
      if (!estWeekEnd(d) && !estFerie(d)) restants -= 1;
    }
    return d;
  }

  function formatLong(chaineDate) {
    var p = String(chaineDate).split('-');
    if (p.length !== 3) return chaineDate;
    return Number(p[2]) + ' ' + MOIS[Number(p[1]) - 1] + ' ' + p[0];
  }

  // Fermetures déclarées par le garage. Échec silencieux volontaire : si l'appel ne passe pas,
  // le calendrier reste utilisable et c'est le serveur qui bloquera la date à la soumission.
  function chargerFermetures(apiBase) {
    if (!apiBase || typeof fetch !== 'function') return Promise.resolve([]);
    return fetch(apiBase + '/api/fermetures')
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data && data.fermetures) || []; })
      .catch(function () { return []; });
  }

  window.MautoCalendrier = {
    CRENEAUX: CRENEAUX,
    RDV_DELAI_HEURES: RDV_DELAI_HEURES,
    RDV_DELAI_JOURS_OUVRES: RDV_DELAI_JOURS_OUVRES,
    MOIS: MOIS,
    JOURS_COURTS: JOURS_COURTS,
    versChaine: versChaine,
    estFerie: estFerie,
    estWeekEnd: estWeekEnd,
    estFermeture: estFermeture,
    estSelectionnable: estSelectionnable,
    dateMinParHeures: dateMinParHeures,
    dateMinParJoursOuvres: dateMinParJoursOuvres,
    formatLong: formatLong,
    chargerFermetures: chargerFermetures,
  };
})();
